import React from 'react';
import {
  Box,
  Container,
  Inline,
  Stack,
  Link,
  Heading,
  Text,
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionContent,
  Divider
} from '@metrewards/react-components';
import { SocialIcon } from 'react-social-icons';

const footerLinks = [
  {
    title: 'IGA Supermarkets',
    links: [
      { href: 'http://new.igashop.com.au/about-us', children: 'About IGA' },
      {
        href: 'http://new.igashop.com.au/promotions',
        children: 'Weekly Specials'
      },
      {
        href: 'http://new.igashop.com.au/new-to-shopping-online',
        children: 'New to Shopping Online?'
      },
      {
        href: 'http://new.igashop.com.au/price-match',
        children: 'Price Match'
      },
      {
        href: 'http://new.igashop.com.au/lped',
        children: 'Low Prices Every Day'
      }
    ]
  },
  {
    title: 'Customer Service',
    links: [
      {
        href: 'http://new.igashop.com.au/support',
        children: 'Support, Help & FAQ'
      },
      {
        href: 'http://new.igashop.com.au/stores',
        children: 'Store Location and Hours'
      },
      {
        href: 'http://new.igashop.com.au/my-orders',
        children: 'My Orders'
      },
      {
        href: 'http://new.igashop.com.au/feedback',
        children: 'Feedback'
      },
      {
        href: 'http://new.igashop.com.au/contact',
        children: 'Contact Us'
      }
    ]
  },
  {
    title: 'Quick Links',
    links: [
      {
        href: 'http://new.igashop.com.au/catalogue',
        children: 'Weekly Catalogue'
      },
      {
        href: 'http://new.igashop.com.au/my-account',
        children: 'My Account'
      },
      {
        href: 'http://new.igashop.com.au/delivery-information',
        children: 'Delivery Information'
      }
    ]
  }
];

function SocialLinks() {
  return (
    <Inline space={4}>
      <Box size={[24, 24, 24, 30]}>
        <SocialIcon
          url="http://facebook.com/igaAustralia"
          network="facebook"
          bgColor="rgb(64, 70, 75)"
          style={{ height: '100%', width: '100%' }}
        />
      </Box>
      <Link href="http://instagram.com/igaAustralia" rel="noreferrer">
        <Box
          as="svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="currentColor"
          size={[24, 24, 24, 30]}
          color="rgb(64, 70, 75)"
        >
          <Box
            as="path"
            id="instagram-a"
            d="M8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,1.77635684e-15 8,1.77635684e-15 C3.581722,1.77635684e-15 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 Z M7.9988872,9.49546712 C8.82418635,9.49546712 9.49322374,8.82642974 9.49322374,8.00113059 C9.49322374,7.17581365 8.82418635,6.50677626 7.9988872,6.50677626 C7.17357026,6.50677626 6.50453288,7.17581365 6.50453288,8.00113059 C6.50453288,8.82642974 7.17357026,9.49546712 7.9988872,9.49546712 Z M7.9988872,5.69902342 C9.27030025,5.69902342 10.3009766,6.72969975 10.3009766,8.00113059 C10.3009766,9.27254364 9.27030025,10.30322 7.9988872,10.30322 C6.72745636,10.30322 5.69678003,9.27254364 5.69678003,8.00113059 C5.69678003,6.72969975 6.72745636,5.69902342 7.9988872,5.69902342 Z M7.9988872,3.5180854 C9.21639786,3.5180854 9.36906495,3.52324608 9.84722844,3.54506329 C10.3243954,3.56682711 10.6502833,3.64261789 10.9354374,3.7534479 C11.2302367,3.86799715 11.4802448,4.02128707 11.7294878,4.27051222 C11.9787129,4.51975516 12.1320029,4.76976331 12.2465699,5.06456257 C12.3573821,5.34971671 12.4331729,5.67560462 12.4549367,6.15277156 C12.4767539,6.63093505 12.4819146,6.78360214 12.4819146,8.00113059 C12.4819146,9.21864125 12.4767539,9.37130834 12.4549367,9.84947182 C12.4331729,10.3266388 12.3573821,10.6525267 12.2465699,10.9376808 C12.1320029,11.2324801 11.9787129,11.4824882 11.7294878,11.7317312 C11.4802448,11.9809563 11.2302367,12.1342462 10.9354374,12.2488133 C10.6502833,12.3596255 10.3243954,12.4354163 9.84722844,12.4571801 C9.36906495,12.4789973 9.21639786,12.484158 7.9988872,12.484158 C6.78135875,12.484158 6.62869166,12.4789973 6.15052818,12.4571801 C5.67336123,12.4354163 5.34747333,12.3596255 5.06231919,12.2488133 C4.76751992,12.1342462 4.51751177,11.9809563 4.26826883,11.7317312 C4.01904369,11.4824882 3.86575376,11.2324801 3.75120451,10.9376808 C3.64037451,10.6525267 3.56458373,10.3266388 3.5428199,9.84947182 C3.52100269,9.37130834 3.51584201,9.21864125 3.51584201,8.00113059 C3.51584201,6.78360214 3.52100269,6.63093505 3.5428199,6.15277156 C3.56458373,5.67560462 3.64037451,5.34971671 3.75120451,5.06456257 C3.86575376,4.76976331 4.01904369,4.51975516 4.26826883,4.27051222 C4.51751177,4.02128707 4.76751992,3.86799715 5.06231919,3.7534479 C5.34747333,3.64261789 5.67336123,3.56682711 6.15052818,3.54506329 C6.62869166,3.52324608 6.78135875,3.5180854 7.9988872,3.5180854 Z M7.9988872,4.32583824 C6.8018591,4.32583824 6.66006503,4.33041167 6.18734694,4.35197975 C5.75025533,4.37191064 5.51288195,4.44494313 5.35491182,4.5063374 C5.14565524,4.58766256 4.9963159,4.68480787 4.83944909,4.84169248 C4.68256449,4.99855929 4.58541918,5.14789862 4.50409401,5.35715521 C4.44269974,5.51512533 4.36966725,5.75249872 4.34973636,6.18959033 C4.32816829,6.66230841 4.32359486,6.80410248 4.32359486,8.00113059 C4.32359486,9.1981409 4.32816829,9.33993497 4.34973636,9.81265306 C4.36966725,10.2497447 4.44269974,10.4871181 4.50409401,10.6450882 C4.58541918,10.8543448 4.68258228,11.0036841 4.83944909,11.1605509 C4.9963159,11.3174355 5.14565524,11.4145808 5.35491182,11.495906 C5.51288195,11.5573003 5.75025533,11.6303327 6.18734694,11.6502636 C6.66001164,11.6718317 6.80177012,11.6764051 7.9988872,11.6764051 C9.19598649,11.6764051 9.33776277,11.6718317 9.81040967,11.6502636 C10.2475013,11.6303327 10.4848747,11.5573003 10.6428448,11.495906 C10.8521014,11.4145808 11.0014407,11.3174355 11.1583075,11.1605509 C11.3151921,11.0036841 11.4123374,10.8543448 11.4936626,10.6450882 C11.5550569,10.4871181 11.6280894,10.2497447 11.6480203,9.81265306 C11.6695883,9.33993497 11.6741618,9.1981409 11.6741618,8.00113059 C11.6741618,6.80410248 11.6695883,6.66230841 11.6480203,6.18959033 C11.6280894,5.75249872 11.5550569,5.51512533 11.4936626,5.35715521 C11.4123374,5.14789862 11.3151921,4.99855929 11.1583075,4.84169248 C11.0014407,4.68480787 10.8521014,4.58766256 10.6428448,4.5063374 C10.4848747,4.44494313 10.2475013,4.37191064 9.81040967,4.35197975 C9.33769159,4.33041167 9.19589752,4.32583824 7.9988872,4.32583824 Z"
          />
        </Box>
      </Link>
      <Box size={[24, 24, 24, 30]}>
        <SocialIcon
          url="http://youtube.com/igaAustralia"
          network="youtube"
          bgColor="rgb(64, 70, 75)"
          style={{ height: '100%', width: '100%' }}
        />
      </Box>
    </Inline>
  );
}

function MobileView() {
  return (
    <Stack space={4} hidden={[false, false, false, true]}>
      <Box px={[4]} sx={{ mx: -4 }}>
        <Divider color="gray.300" />
        <Accordion>
          {footerLinks.map(section => (
            <AccordionItem key={section.title}>
              <AccordionButton>{section.title}</AccordionButton>
              <AccordionContent>
                <Stack space={4}>
                  {section.links.map(link => (
                    <Link
                      key={link.href}
                      variant="footerAccordion"
                      rel="noreferrer"
                      {...link}
                    />
                  ))}
                </Stack>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <Divider color="gray.300" sx={{ mt: 2 }} />
      </Box>
      <Box py={4} display="flex" justifyContent="center">
        <Heading
          hidden={[true, true, false]}
          as="h3"
          fontSize={2}
          color="brandGray.600"
        >
          Follow Us
        </Heading>

        <SocialLinks />
      </Box>
    </Stack>
  );
}

function DesktopView() {
  return (
    <Container>
      <Inline width="100%" space={6} hidden={[true, true, true, false]}>
        {footerLinks.map(section => (
          <Box key={section.title}>
            <Stack space={4}>
              <Heading as="h3" fontSize={2} color="brandGray.600">
                {section.title}
              </Heading>
              <Stack>
                {section.links.map(link => (
                  <Link key={link.href} rel="noreferrer" {...link} />
                ))}
              </Stack>
            </Stack>
          </Box>
        ))}
        <Box display="flex" justifySelf="flex-end">
          <Box>
            <Stack space={6}>
              <Heading as="h3" fontSize={2} color="brandGray.600">
                Follow Us
              </Heading>

              <SocialLinks />
            </Stack>
          </Box>
        </Box>
      </Inline>
    </Container>
  );
}

function BottomFooterNav() {
  return (
    <Box bg="brandGray.500" color="white">
      <Container py={16} px={2}>
        <Stack space={2}>
          <Inline
            space={5}
            align={['center', 'center', 'center', 'start']}
            alignY="center"
          >
            <Text hidden={[true, true, true, false]} fontSize={0}>
              © 2020 IGA
            </Text>
            <Link
              variant="bottomFooterNav"
              href="http://new.igashop.com.au/privacy-policy"
              rel="noreferrer"
            >
              Privacy Policy
            </Link>
            <Link
              variant="bottomFooterNav"
              href="http://new.igashop.com.au/terms-conditions"
              rel="noreferrer"
            >
              Terms & Conditions
            </Link>
            <Link
              variant="bottomFooterNav"
              href="https://iga.com.au/"
              rel="noreferrer"
            >
              IGA.com.au
            </Link>
          </Inline>
          <Text
            hidden={[false, false, false, true]}
            fontSize={0}
            textAlign="center"
          >
            © 2020 IGA
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}

function Footer() {
  return (
    <Box as="footer" bg="brandGray.100" sx={{ mt: 'auto' }}>
      <Container px={2} py={[6, 6, 6, 56]} maxWidth={5}>
        <MobileView />
        <DesktopView />
      </Container>
      <BottomFooterNav />
    </Box>
  );
}

export { Footer };
